var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1853 8.76929C19.2725 7.3316 20.6546 5.16533 20.6546 3.44244C20.6546 1.54123 18.9732 0 16.8992 0C14.8252 0 13.1438 1.54123 13.1438 3.44244C13.1438 5.16533 14.5259 7.3316 15.6132 8.76929C16.8992 10.0553 16.8992 10.0553 18.1853 8.76929ZM16.8992 4.69423C17.4177 4.69423 17.8381 4.27389 17.8381 3.75538C17.8381 3.23688 17.4177 2.81654 16.8992 2.81654C16.3807 2.81654 15.9604 3.23688 15.9604 3.75538C15.9604 4.27389 16.3807 4.69423 16.8992 4.69423ZM13.3383 7.31632C13.7049 7.68297 13.5105 7.85075 13.1438 8.21739L9.38846 11.9728C9.02184 12.3394 8.6218 12.7661 8.25517 12.3994C7.88853 12.0328 8.20405 11.7539 8.57069 11.3872L12.3261 7.63185C12.6927 7.26521 12.9717 6.94968 13.3383 7.31632ZM7.51077 14.7086C7.51077 16.4315 6.12873 18.5978 5.04146 20.0354C3.75538 21.3215 3.75538 21.3215 2.46931 20.0354C1.38204 18.5978 0 16.4315 0 14.7086C0 12.8074 1.68134 11.2662 3.75538 11.2662C5.82943 11.2662 7.51077 12.8074 7.51077 14.7086ZM4.69423 15.0215C4.69423 15.5401 4.27389 15.9604 3.75538 15.9604C3.23688 15.9604 2.81654 15.5401 2.81654 15.0215C2.81654 14.503 3.23688 14.0827 3.75538 14.0827C4.27389 14.0827 4.69423 14.503 4.69423 15.0215Z",
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfers);
export default __webpack_public_path__ + "static/media/Transfers.f62ef8bd.svg";
export { ForwardRef as ReactComponent };